import isNil from "ramda/es/isNil";
import isNumeric from "ramda-extension/es/isNumeric";
import textValidations from '../text';
/**
 * Validate number
 *
 * @documented
 * @category Number
 * @import import { isNumber } from '@gef-ui/validations/validationFunctions/number'
 * @param {Object} input
 * @param {Number} [input.min]
 * @param {Number} [input.max]
 * @returns {String} errMessage
 *
 */ function isNumber({ min = null, max = null }) {
    return ({ fieldValue })=>{
        let result = false;
        const forbiddenChars = new RegExp('[e,x]');
        if (isNumeric(fieldValue) && !forbiddenChars.test(fieldValue)) {
            const num = Number(fieldValue);
            if (!isNil(min) && num < min) {
                result = 'numberMinValue';
            } else if (!isNil(max) && num > max) {
                result = 'numberMaxValue';
            }
        } else {
            result = 'shouldBeNumber';
        }
        return result;
    };
}
/**
 * Validate ic
 *
 * @documented
 * @category Number
 * @import import { isIc } from '@gef-ui/validations/validationFunctions/number'
 * @returns {String} errMessage
 *
 */ function isIc() {
    return ({ fieldValue, ...rest })=>{
        let result = false;
        const value = fieldValue.trim();
        const hasNonDigit = hasOnlyDigits()({
            fieldValue: value,
            ...rest
        });
        if (hasNonDigit) {
            return hasNonDigit;
        }
        const hasExactLength = textValidations.isString({
            length: 8
        })({
            fieldValue: value,
            ...rest
        });
        if (hasExactLength) {
            return hasExactLength;
        }
        let a = 0;
        if (value.length === 8) {
            const b = value.split('');
            let c = 0;
            for(let i = 0; i < 7; i++){
                a += parseInt(b[i], 10) * (8 - i);
            }
            a = a % 11;
            c = 11 - a;
            if (a === 1) {
                c = 0;
            } else if (a === 0 || a === 10) {
                c = 1;
            }
            if (parseInt(b[7], 10) !== c) {
                result = 'icNotCorrect';
            }
        } else {
            result = 'icNotCorrect';
        }
        return result;
    };
}
/**
 * Validate digits
 *
 * @documented
 * @category Number
 * @import import { hasOnlyDigits } from '@gef-ui/validations/validationFunctions/number'
 * @returns {String} errMessage
 *
 */ function hasOnlyDigits() {
    return textValidations.onlyAllowedChars({
        regex: /[^0-9-]/,
        messageKey: 'shouldHaveOnlyDigits'
    });
}
function isZip({ allowSpace }) {
    return (args)=>{
        if (allowSpace) {
            return textValidations.onlyAllowedChars({
                regex: /^(?!(\d{3} ?\d{2})$)/,
                messageKey: 'zipNotCorrect'
            })(args);
        }
        return textValidations.isString({
            length: 5
        })(args) || hasOnlyDigits()(args);
    };
}
export default {
    isNumber,
    isIc,
    hasOnlyDigits,
    isZip
};
